<template>
  <g x="0" y="0" :width="width" :height="height" class="not-copy">
    <!-- 下地 -->
    <rect fill="#98fb98" :x="-width" :y="-height" :width="width * 8" :height="height * 8"/>
    <!-- 装飾 -->
    <ellipse v-for="i in 20" :key="i + '-1'" fill="#aee6ae" :cx="randomCXCY()" :cy="randomCXCY()" :transform="randomRotate()" rx="20" ry="40"/>
    <circle  v-for="i in 30" :key="i + '-2'" fill="#0f0" :cx="randomCXCY()" :cy="randomCXCY()" r="10"/>
  </g>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'GreenGrassOffice',
  componentName: 'GreenGrassOffice',
  props: ['width', 'height'],
  data () {
    return {
    }
  },
  methods: {
    randomNumber (min, max) {
      return Math.floor( Math.random() * (max + 1 - min) ) + min
    },
    randomCXCY () {
      return this.randomNumber(1, 1000)
    },
    randomRotate () {
      return 'rotate(' + this.randomNumber(0, 50) + ')'
    }
  }
}
</script>

<style lang="scss" scoped>
.not-copy {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/VirtualOffice/Landscape/GreenGrassOffice.vue